import React, { useState } from 'react';
import App from '../spelling-app/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from '@/components/ui/card';

const SpellingAuth = () => {
    const [password, setPassword] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [error, setError] = useState('');

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        if (password === 'erbgrow') {
            setIsAuthenticated(true);
            setError('');
        } else {
            setError('Incorrect password');
        }
    };

    if (isAuthenticated) {
        return <App />;
    }

    return (
        <div className="flex items-center justify-center min-h-[70vh] bg-paper">
            <Card className="w-[350px] bg-white/90 shadow-xl border-[#A65D3F]/20">
                <CardHeader>
                    <CardTitle className="text-center serif text-2xl text-[#3D2B1F]">Restricted Access</CardTitle>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleLogin}>
                        <div className="grid w-full items-center gap-4">
                            <div className="flex flex-col space-y-1.5">
                                <Input
                                    id="password"
                                    type="password"
                                    placeholder="Enter access code..."
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="font-mono text-center border-[#A65D3F]/30 focus:border-[#C9A227] focus:ring-[#C9A227]"
                                />
                            </div>
                            {error && <p className="text-[#A65D3F] text-sm text-center font-bold tracking-wide">{error}</p>}
                        </div>
                    </form>
                </CardContent>
                <CardFooter className="flex justify-center pb-8">
                    <Button
                        onClick={handleLogin}
                        className="bg-[#A65D3F] hover:bg-[#8C4E35] text-white serif tracking-widest uppercase text-xs px-8 py-2"
                    >
                        Unlock
                    </Button>
                </CardFooter>
            </Card>
        </div>
    );
};

export default SpellingAuth;
